import React, { useState, useCallback } from 'react';
import { DmsPage, DmsTabber, DmsAltBox, intl } from 'dmsbasereact';
import { Typography } from '@mui/material';
import { CheckinTable } from '../../components/CheckinCheckoutForm/CheckinTable';
import { ManualCheckinForm } from '../../components/CheckinCheckoutForm/ManualCheckinForm';
import { InvoiceDocumentTable } from '../../components/InvoiceDocumentTable/InvoiceDocumentTable';
import { InvoiceDocumentDetailModal } from '../../components/InvoiceDocumentTable/InvoiceDocumentDetailModal';

export const CheckinPage = () => {
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [manualModalOpen, setManualModalOpen] = useState(false);
    const [manualFormKey, setManualFormKey] = useState(0);
    const [manualInitialData, setManualInitialData] = useState(null);
    const [checkinTableKey, setCheckinTableKey] = useState(0);

    const handleViewDetails = useCallback((row) => {
        setSelectedInvoice(row);
        setDetailModalOpen(true);
    }, []);

    const handleCloseDetailModal = useCallback(() => {
        setDetailModalOpen(false);
        setSelectedInvoice(null);
    }, []);

    const handleOpenManualModal = useCallback(() => {
        setManualInitialData(null);
        setManualFormKey(prev => prev + 1);
        setManualModalOpen(true);
    }, []);

    const handleCloseManualModal = useCallback(() => {
        setManualModalOpen(false);
        setManualInitialData(null);
    }, []);

    const handleManualSuccess = useCallback(() => {
        setCheckinTableKey(prev => prev + 1);
    }, []);

    const handleCorrectInvoice = useCallback((invoice, enrichedInvoice) => {
        const items = enrichedInvoice?.invoice_document_items || invoice.items || [];
        const data = {
            originPk: invoice.owner_entity_pk,
            destinationPk: invoice.destination_entity_pk,
            danfeNumber: invoice.danfe_number || '',
            isCorrection: true,
            originalInvoicePk: invoice.pk,
            items: items.map((item, idx) => ({
                id: Date.now() + idx,
                batchNumber: item.batch?.number || item.batch_number || '',
                productNumber: item.batch?.part?.number || '',
                quantity: item.quantity || 1,
                batchValid: null,
                productValid: null,
                batchInfo: null,
                productInfo: null,
                validating: false,
            })),
        };
        setManualInitialData(data);
        setManualFormKey(prev => prev + 1);
        setManualModalOpen(true);
    }, []);

    const tabs = [
        {
            title: intl.get("Checkin.PendingTab").d("Pending Invoices"),
            component: (
                <CheckinTable
                    key={checkinTableKey}
                    onCorrectInvoice={handleCorrectInvoice}
                    onManualEntry={handleOpenManualModal}
                />
            )
        },
        {
            title: intl.get("Checkin.HistoryTab").d("History"),
            component: (
                <InvoiceDocumentTable
                    url="/invoice_document/table?my_institutions=true&direction=inbound"
                    onViewDetails={handleViewDetails}
                    readOnlyLabel=""
                    createdByLabel={intl.get("ReceivedBy").d("Received by")}
                />
            )
        },
    ];

    return (
        <>
            <DmsPage name={intl.get("Checkin.PageTitle").d("Entry")}>
                <DmsAltBox.Card>
                    <DmsAltBox.Header>
                        <Typography variant='h3' sx={{ fontSize: '1.1rem' }}>
                            {intl.get("Checkin.PageTitle").d("Entry")}
                        </Typography>
                    </DmsAltBox.Header>
                    <DmsAltBox.Body sx={{ overflow: 'auto' }}>
                        <DmsTabber tabs={tabs} pageName={intl.get("Checkin.PageTitle").d("Entry")} />
                    </DmsAltBox.Body>
                </DmsAltBox.Card>
            </DmsPage>

            <ManualCheckinForm
                key={manualFormKey}
                open={manualModalOpen}
                onClose={handleCloseManualModal}
                initialData={manualInitialData}
                onSuccess={handleManualSuccess}
            />

            <InvoiceDocumentDetailModal
                open={detailModalOpen}
                onClose={handleCloseDetailModal}
                invoice={selectedInvoice}
                createdByLabel={intl.get("ReceivedBy").d("Received by")}
            />
        </>
    );
};
